import { render } from "./linkSyndrome.vue?vue&type=template&id=62513cee"
import script from "./linkSyndrome.vue?vue&type=script&lang=js"
export * from "./linkSyndrome.vue?vue&type=script&lang=js"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__